import { render, staticRenderFns } from "./SearchResultCount.vue?vue&type=template&id=11420114&"
import script from "./SearchResultCount.vue?vue&type=script&lang=ts&"
export * from "./SearchResultCount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports